var _defs, _polygon, _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawnexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fdba68;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1663.92 641.27 1663.92 1558.15 1582.61 1604.21 1518.17 1640.69 1434.68 1687.98 1372.42 1723.24 1286.84 1771.67 1286.75 1771.67 1226.57 1805.78 1138.82 1855.53 1080.82 1888.32 990.98 1939.21 935.06 1907.56 843.14 1855.53 843.04 1855.53 789.22 1824.92 695.21 1771.67 643.46 1742.38 547.27 1687.98 497.71 1659.84 399.34 1604.21 351.96 1577.3 351.96 641.27 497.71 641.27 497.71 1492.38 547.18 1520.43 643.46 1574.92 695.21 1604.21 789.22 1657.47 843.04 1687.98 935.06 1740.11 990.98 1771.76 1080.82 1720.87 1138.91 1687.98 1226.57 1638.33 1286.75 1604.21 1372.42 1555.69 1434.78 1520.43 1518.17 1473.15 1518.17 641.27 1663.92 641.27"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.98,
    y: 61.4,
    width: 1872.78,
    height: 145.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 210.77,
    y: 348.53,
    width: 1579.2,
    height: 145.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1214.91,1479.29,763.49,854l30.26,7.57,2.16,633.82L646.4,1408.31V636.79L777,639.69l471.45,612.08-31.84,59.92L1223,722l148.91-80.56.54,746.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawnexLogo);
export default __webpack_public_path__ + "static/media/lawnexLogo.ff1be29a6c52dcd9c06560dad5e25652.svg";
export { ForwardRef as ReactComponent };